export default {"src":"/_next/static/media/smile.d96cde44.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};